export default __webpack_public_path__ + "static/media/banners_working_chimp2.5ed5596f.png";